import * as React from 'react'

import PhotoAlbum from 'react-photo-album'
import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'
import Zoom from 'yet-another-react-lightbox/plugins/zoom'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useState } from 'react'
import {
  imagesGalleryModal,
  imagesSlidesModal,
} from '../../DetailPageDataUtils'
import axios from 'axios'
import { useEffect } from 'react'
import { isEmpty } from 'lodash'

// import photos from './Photos'
// import slides from './Slides'

const PhotoGallery = (props) => {
  const [photoList, setphotoList] = useState([])
  const [slideList, setSlideList] = useState([])
  const [imagesList, setImagesList] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [totalResults, setTotalResults] = useState(0)
  const [index, setIndex] = React.useState(-1)

  const [open, setOpen] = React.useState(false)
  const [animationDuration, setAnimationDuration] = React.useState(500)
  const [maxZoomPixelRatio, setMaxZoomPixelRatio] = React.useState(1)
  const [zoomInMultiplier, setZoomInMultiplier] = React.useState(2)
  const [doubleTapDelay, setDoubleTapDelay] = React.useState(300)
  const [doubleClickDelay, setDoubleClickDelay] = React.useState(300)
  const [doubleClickMaxStops, setDoubleClickMaxStops] = React.useState(2)
  const [keyboardMoveDistance, setKeyboardMoveDistance] = React.useState(50)
  const [wheelZoomDistanceFactor, setWheelZoomDistanceFactor] = React.useState(
    100,
  )
  const [pinchZoomDistanceFactor, setPinchZoomDistanceFactor] = React.useState(
    100,
  )
  const [scrollToZoom, setScrollToZoom] = React.useState(false)

  console.log('>>>>props.images', props.images)
  console.log('>>>>photoList', photoList)
  console.log('>>>>props.imagesSlides', props.imagesSlides)
  console.log('>>>>SlideList', slideList)
  useEffect(() => {
    setphotoList(props.images)
    setSlideList(props.imagesSlides)
    setImagesList(props.images)

    // return () => {
    //   console.log('unmounted Gallery')
    //   setphotoList([])
    //   setSlideList([])
    //   setImagesList([])
    // }
  }, [])

  const fetchMoreData = async () => {
    setPage(page + 1)
    try {
      var url = `https://tripdevapi.unravelapp.com/api/v1/item/images?itemId=${props.id}&pageNumber=${page}&pageSize=20`
      var host = window.location.hostname
      if (host === 'trip.unravelapp.com' || host === 'trips.unravelapp.com') {
        var url = `https://tripapi.unravelapp.com/api/v1/item/images?itemId=${props.id}&pageNumber=${page}&pageSize=20`
      }

      let response = await axios.get(url, {
        headers: { token: `${props.tokenStr}` },
      })

      // dispatch(getImagesGalleryData(response.data.data))
      let imagesArr = imagesGalleryModal(response.data.data)
      let slideArr = imagesSlidesModal(response.data.data)
      if (!isEmpty(photoList)) {
        setphotoList(photoList.concat(imagesArr))
      } else {
        setphotoList(props.images.concat(imagesArr))
      }
      setSlideList(slideList.concat(slideArr))
      // console.log(imagesList)
      console.log(response.data.data.page)
    } catch (error) {
      throw Error(error)
    }
  }

  // console.log(' props.images.length', props.images.length)
  // console.log(
  //   ' props.totalPages.total_elements',
  //   props.totalPages.total_elements,
  // )
  // console.log(' photoList.length', photoList.length)

  return (
    <>
      {!isEmpty(photoList) && (
        <>
          <PhotoAlbum
            layout="rows"
            photos={
              isEmpty(photoList)
                ? props.images
                : photoList.length < props.images.length
                ? props.images
                : photoList
            }
            targetRowHeight={250}
            onClick={({ index }) => setIndex(index)}
          />
          {!isEmpty(props.totalPages) &&
            photoList.length < props.totalPages.total_elements &&
            props.images.length < props.totalPages.total_elements && (
              <p
                className="headline2"
                style={{
                  textAlign: 'center',
                  border: '1px solid var(--primaryShades20)',
                  color: 'var(--primaryShades20)',
                  padding: '3px',
                  cursor: 'pointer',
                }}
                onClick={fetchMoreData}
              >
                Load more..
              </p>
            )}
        </>
      )}

      <Lightbox
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        slides={
          isEmpty(slideList)
            ? props.imagesSlides
            : slideList.length < props.imagesSlides.length
            ? props.imagesSlides
            : slideList
        }
        plugins={[Zoom]}
        animation={{ zoom: animationDuration }}
        zoom={{
          maxZoomPixelRatio,
          zoomInMultiplier,
          doubleTapDelay,
          doubleClickDelay,
          doubleClickMaxStops,
          keyboardMoveDistance,
          wheelZoomDistanceFactor,
          pinchZoomDistanceFactor,
          scrollToZoom,
        }}
      />
    </>
  )
}

export default PhotoGallery
